import React, { useState, useContext, useEffect } from 'react';

import { Input, Button, Step, ActionLink } from '../../atoms';
import { AuthService } from '../../../services';
import { UserContext } from '../../../context';
import { validateEmail } from '../../../utils/input.validator';
import { default as t } from '../../../utils/i18n';

import './create-user-account.scss';

function CreateUserAccount({ atStep, updateStep }) {
  const { setUser } = useContext(UserContext);

  const [email, setEmail] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [validationError, setValidationError] = useState(null);

  const loadingDefaultState = {
    buttonText: t('user.checkEmailAddress'),
    buttonClass: '',
    loadingIcon: false
  };
  const [isLoading, setIsLoading] = useState(loadingDefaultState);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const handleChange = e => {
    e.preventDefault();
    setValidationError(null);
    const emailPattern = /\S+@\S+\.\S+/;
    const { value } = e.target;
    if (value && emailPattern.test(value)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
    setEmail(value);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    let errorMessage = validateEmail(email);
    if (errorMessage) {
      return setValidationError(errorMessage);
    }

    setIsLoading({
      buttonClass: 'button-checking',
      buttonText: `${t('signup.button.checking')}`,
      loadingIcon: true
    });

    try {
      const checkUserResponse = await AuthService.checkUser(email.toLowerCase());
      if(checkUserResponse?.data?.data?.code) {
        setValidationError(t(`error.${checkUserResponse?.data?.data?.code}`));
      } else {
        setUser(prevUserState => ({
          ...prevUserState,
          username: checkUserResponse.data?.data?.username,
          name: checkUserResponse.data?.data?.name,
          signup: {
            step: 2,
          }
        }));
        updateStep(2);
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        setValidationError(t(`error.${dataCode}`));
      }
      else{
        const errmsg = error?.data?.data?.message
        if(errmsg){setValidationError(errmsg.toString());}
        
      }
    }
    setIsLoading(loadingDefaultState);
  };

  if (!isMounted) {
    return null;
  }

  return (
    <div className="signup-step1__card-container">
      <p className="signup-step1__heading">{t('signup.step1.heading')}</p>
      {/* <div className="signup-step1__step-container">
          <Step atStep={atStep}></Step>
        </div> */}
      <p className="signup-step1__subheading">{t('signup.step1.subHeading')}</p>
      <div className="signup-step1__form-group">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <Input
              labelValue={t('user.input.label.emailAddress')}
              emailToolTip={t('user.input.tooltip.emailAddress')}
              name="email"
              fieldType="email"
              placeholder={t('user.input.placeholder.emailAddress')}
              value={email}
              handleChange={handleChange}
              errorMessage={validationError}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
            />
          </div>

          <div className="button-container">
            <Button
              type="submit"
              name="submit"
              label={isLoading.buttonText}
              className={isLoading.buttonClass}
              disabled={disableButton}
              loader={isLoading.loadingIcon}
            />
          </div>
        </form>

     
        <div className="signup-step1__footer">
          {t('signup.step1.footer')}{' '}
          <span className="signup-step1__footer--link">
            <ActionLink value={t('user.link.signInNow')} redirectTo="/signIn" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default CreateUserAccount;
